import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../Components/i18n";
import { client } from "./Socket";
import "./Report.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FileDown, ArrowUp, ArrowDown } from "lucide-react";

export const sendData = (topic, value) => {
  client.publish(topic, value);
};

function MotorReport({ children, toggleLanguage }) {
  const [loading2, setLoading2] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const [filteredData, setFilteredData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const { t } = useTranslation();

  const fetchDevice = async () => {
    try {
      const resDevices = await fetch("https://api.db2sg.com/esps", {
        method: "GET",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      });
      const result = await resDevices.json();
console.log(result,"66666")
      const resUsers = await fetch("https://db2sg.com/HamitaherApi/user.php", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      });
      const res = await resUsers.json();

      const updatedData = result?.data?.map((device) => {
        const userWithDevice = res.find((user) => {
          const deviceData = user?.devices && user.devices[device.id];
          return deviceData;
        });
        return {
          ...device,
          user: userWithDevice ? userWithDevice.name : "Unknown",
          deviceInfo: userWithDevice ? { ...userWithDevice } : null,
        };
      });

      setFilteredData(updatedData);
      setLoading2(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDevice();
  }, []);

  // Sorting logic
  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return filteredData;

    const sorted = [...filteredData].sort((a, b) => {
      let aVal, bVal;
      switch (sortConfig.key) {
        case "id":
          aVal = a.id;
          bVal = b.id;
          break;
        case "deviceName":
          aVal = a.deviceName || "";
          bVal = b.deviceName || "";
          break;
        case "motorHours":
          const aMin = a.new_total_time || 0;
          const bMin = b.new_total_time || 0;
          aVal = aMin;
          bVal = bMin;
          break;
        default:
          aVal = "";
          bVal = "";
      }

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredData, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />;
  };

  // PDF export
  const exportPDF = () => {
    const doc = new jsPDF("portrait", "pt", "A4");
    doc.setFontSize(22);
    doc.setTextColor(225, 184, 75);
    doc.text("Motor Hours Report", 40, 40);
    doc.setFontSize(12);
    doc.setTextColor(80, 80, 80);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 40, 60);

    autoTable(doc, {
      startY: 80,
      head: [["Device Name", "Device ID", "Motor Hours"]],
      body: sortedData.map((row) => {
        const minutes = row.new_total_time || 0;
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const formatted = `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")} h`;
        return [row.deviceName || "--", row.id, formatted];
      }),
      styles: { fontSize: 12, cellPadding: 8 },
      headStyles: { fillColor: [225, 184, 75], textColor: 0, fontSize: 14, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 245, 245] },
    });
    doc.save("Motor_Report.pdf");
  };
  const exportFilteredPDF = () => {
    const doc = new jsPDF("portrait", "pt", "A4");
  
    doc.setFontSize(22);
    doc.setTextColor(225, 184, 75);
    doc.text("Motor Filter Report", 40, 40);
  
    doc.setFontSize(12);
    doc.setTextColor(80, 80, 80);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 40, 60);
  
    autoTable(doc, {
      startY: 80,
      head: [["Device ID","User","Target Hours", "Useage Hours", "Percentage"]],
      body: filteredData.map((row) => {
        const minutes = row.new_total_time || 0;
        const hrs = (minutes / 60).toFixed(2); // convert to hours
        const targetHours = Number(row.target_hour) || 2000;
        const percentage = Math.min((hrs / targetHours) * 100, 100).toFixed(2);
  
        return [row.id,row?.deviceInfo?.name||"--", targetHours, hrs, `${percentage}%`];
      }),
      styles: { fontSize: 12, cellPadding: 8 },
      headStyles: { fillColor: [225, 184, 75], textColor: 0, fontSize: 14, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 245, 245] },
    });
  
    doc.save("Motor_Filter_Report.pdf");
  };
  
  return (
    <>
      <SideBar />
      <div className="topbar" style={{ backgroundColor: "rgba(0,0,0,0.8)" }}>
        <div className="container-fluid devices_topbar">
          <div className="row d-flex align-items-center justify-content-evenly">
            <div className="col text-center px-3 d-flex flex-start">
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "100%",
                  background:
                    "linear-gradient(45deg, #Ae8625, #f7ef8a, #d2ac47, #edc967)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </span>
            </div>

            <div
              className="col-2 d-flex align-items-center"
              style={{ width: "160px", justifyContent: "space-between" }}
            >
              {/* <button
                onClick={() => setShowMap((prev) => !prev)}
                className="btn"
                style={{
                  background: !anyUserSelected
                    ? "grey"
                    : "linear-gradient(45deg, #Ae8625, #f7ef8a, #d2ac47,#edc967)",
                  color: !anyUserSelected ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              >
                {showMap ? "Show Table" : "Show Map"}
              </button> */}

              <span
                style={{
                  color: "#000",
                  background:
                    "linear-gradient(45deg, #Ae8625, #f7ef8a, #d2ac47, #edc967)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "100%",
                  marginLeft: "20px",
                }}
              >
                {i18n.language === "en" ? "Hebrew" : "Hebrew"}
              </span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={i18n.language === "he"}
                  onChange={toggleLanguage}
                  name="loading"
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* {loading2 ? (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      ) : ( */}
            <div className="content">

        <div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="report-title">{t("Motor Hours Report")}</h2>
            <button onClick={exportPDF} className="export-btn">
              <FileDown size={23} style={{ color: "#000" }} /> {t("Export PDF")}
            </button>
            <button onClick={exportFilteredPDF} className="export-btn" style={{marginLeft:"10px"}}>
  <FileDown size={23} style={{ color: "#000" }} /> {t("Export Filter Report")}
</button>

          </div>

          <div className="table-box">
            <table className="table">
              <thead className="table-header">
                <tr>
                  <th onClick={() => requestSort("id")}>
                    {t("Id")} {getSortArrow("id")}
                  </th>
                  <th onClick={() => requestSort("deviceName")}>
                    {t("Device Name")} {getSortArrow("deviceName")}
                  </th>
                  <th onClick={() => requestSort("motorHours")}>
                    {t("Motor Hours")} {getSortArrow("motorHours")}
                  </th>
                  <th onClick={() => requestSort("percentage")}>
  {t("Percentage")} {getSortArrow("percentage")}
</th>
                  <th>{t("Action")}</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((row) => (
                  <tr key={row.id}>
                    <td
                      onClick={() => {
                        if ((row?.deviceInfo?.devices || "{}")[row.id]?.provisioned) {
                          navigate("/devicesdata", {
                            state: {
                              deviceName: row.deviceName,
                              enabled: (row?.deviceInfo?.devices || "{}")[row.id]?.enabled,
                              esp_id: row.id,
                              provisioned: (row?.deviceInfo?.devices || "{}")[row.id]?.provisioned,
                              user: row.deviceInfo,
                            },
                          });
                        } else {
                          alert("Device not provisioned: First provision it from the app");
                        }
                      }}
                      style={{ color: "#E1B84B", textDecoration: "underline", cursor: "pointer" }}
                    >
                      {row.id}
                    </td>
                  
                    <td>{row.deviceName || "--"}</td>
                    <td style={{ color: "#E1B84B" }}>
                      {(() => {
                        const minutes = row.new_total_time || 0;
                        const hrs = Math.floor(minutes / 60);
                        const mins = minutes % 60;
                        return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
                      })()} h
                    </td>
                    <td>
  {(() => {
    const minutes = row.new_total_time || 0;
    const hrs = minutes / 60; // convert to hours
    const percentage = Math.min(((hrs / (Number(row.target_hour) || 2000)) * 100), 100).toFixed(2);

    return (
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${percentage}%` }}>
        <span style={{zIndex:"20",position:"absolute",textAlign:"center",
      marginLeft:"3.2%",marginTop:"2px"}}>{percentage}%</span>
        </div>
      
      </div>
    );
  })()}
</td>

                    <td>
                      <button
                        className="reset-btn"
                        onClick={async () => {
                          sendData(`${row?.id}/reset_total_time`, "0");
                          fetchDevice();
                        }}
                      >
                        {t("Reset")}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      {/* )} */}
       <style>
        {`
          .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-left-color: #E1B84B;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            display:flex
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0% {
              box-shadow: 0 0 5px #28a745;
            }
            50% {
              box-shadow: 0 0 15px #28a745;
            }
            100% {
              box-shadow: 0 0 5px #28a745;
            }
          }
          .progress-container {
            width: 100%;
            background-color: #e0e0e0;
            border-radius: 8px;
            height: 20px;
            overflow: hidden;
          }
          
          .progress-bar {
            height: 100%;
            background: linear-gradient(90deg, #E1B84B, #f7ef8a);
            text-align: right;
            padding-right: 5px;
            color: #000;
            font-size: 12px;
            line-height: 20px;
            border-radius: 8px 0 0 8px;
          }
          
          
        `}

      </style>
      </div>
    </>
  );
}

export default MotorReport;
